import { useAvatarService } from 'nekst-api';
import { AfterSubmitFunc, FormTemplate } from 'ui-builder';

import { EditAvatarInputWidget } from './EditAvatarInputWidget';

interface EditAvatarFormProps {
  personId: number;
  afterSubmitFunc?: AfterSubmitFunc;
}

export function EditAvatarForm(props: EditAvatarFormProps) {
  const avatarService = useAvatarService();
  return (
    <FormTemplate<{ file: string }>
      title="Upload Profile Photo"
      submitFormFunc={async (data) => {
        await avatarService.uploadAvatar(props.personId, data.file);
        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <EditAvatarInputWidget source="file" />
    </FormTemplate>
  );
}
